<app-hero-courses></app-hero-courses>
<!-- <div class="first container grid">
  <div class="row my-4">
    <div class="col-xl d-flex justify-content-center align-items-center my-3">
      <img src="../../../../assets/img/educatori.png" alt="Educatori" />
    </div>
    <div class="col-xl d-flex justify-content-center align-items-center mt-5">
      <img src="../../../../assets/img/12moduli.png" alt="" />
    </div>
  </div>
</div> -->

<div class="second container grid">
  <h3 class="w-700 blue-50 text-center">
    Il coding e la robotica a portata di mano.
  </h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Per imparare le materie scientifiche alla base della
    <span class="underline-p">programmazione</span> tramite la costruzione e lo
    <span class="underline-a">sviluppo di un robot</span>. Durante il corso
    viene utilizzato un kit robot (mBot) che si può programmare grazie a un
    software (mBlock) che permette di imparare i concetti della programmazione
    in modo grafico.
  </p>
</div>

<div class="third container grid">
  <div class="title">
    <h3 class="w-700 blue-50 text-center">
      Un'interfaccia semplice e intuitiva'.
    </h3>
  </div>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Il software mBlock, utilizzato per programmare il robot, deriva da Scratch
    2.0 e ha un’interfaccia semplice e intuitiva grazie al linguaggio di
    programmazione visuale a blocchi.
  </p>
  <div class="d-flex justify-content-center align-items-center mt-5 pt-5">
    <img
      src="../../../../assets/img/er-1.png"
      alt="Interfaccia Scratch"
     
      class="er-1"
    />
  </div>
</div>

<div class="fourth container grid">
  <div class="title">
    <h3 class="w-700 blue-50 text-center">
      Un'interfaccia semplice e intuitiva'.
    </h3>
  </div>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Il software mBlock, utilizzato per programmare il robot, deriva da Scratch
    2.0 e ha un’interfaccia semplice e intuitiva grazie al linguaggio di
    programmazione visuale a blocchi.
  </p>
</div>

<div class="fifth container grid">
  <div class="title">
    <h3 class="w-700 blue-50 text-center">
      Impara i concetti della programmazione in modo grafico e divertente.
    </h3>
  </div>
  <div class="row">
    <div class="col-xl">
      <img
        src="../../../../assets/img/er-2.png"
        alt="Interfaccia Scratch"
       
        class="rect-2a"
      />
    </div>
    <div class="col-xl"></div>
  </div>
  <div class="row">
    <div class="col-xl"></div>
    <div class="col-xl">
      <img
        src="../../../../assets/img/er-3.png"
        alt="Interfaccia Scratch"
       
        class="rect-2b"
      />
    </div>
  </div>
</div>

<div class="sixth container grid">
  <div class="title">
    <h3 class="w-700 blue-50 text-center">
      Il concetto di robot in un unico kit.
    </h3>
  </div>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Grazie al kit mBot gli alunni potranno toccare con mano il concetto di
    Robot, dalle parti meccaniche alla sua programmazione. Verranno analizzate
    le molteplici funzioni che può avere l’utilizzo di un robot in diverse
    applicazioni della quotidianità (es. un microcontroller).
  </p>
</div>

<div class="seventh container grid">
  <div class="row text-center">
    <div class="col-xl">
      <img
        src="../../../../assets/img/er-4.png"
        alt="mBot Scratch"
       
        class="er-4"
      />
    </div>
  </div>
</div>

<app-modules [data]="modulesText"></app-modules>
<app-iscriviti></app-iscriviti>
